module.exports = __webpack_public_path__ + "static/media/main-visual-03.3a78fe0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-03.mp4
// module id = EFCa
// module chunks = 1